/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */
 $(document).ready(function(){
   $('#customer_login').on('click', '.Form__Submit', function (e) {
     e.preventDefault();

     if (window.localStorage) {
       localStorage.setItem("login_current", true);
     }

     $(this).closest('form').submit();
   });

   
   setTimeout(function () {
    $('.equals-height-product').equalHeights();

    $('.flickity-slider .equals-height-product').equalHeights();
  }, 1000);


  if ($(window).width() > 1008) {
    var heightInfo = $('.Product__Info').innerHeight();
    var heightImage = $('.Product__Slideshow').innerHeight();

    if (heightInfo > heightImage) {
      $('.Product').height(heightInfo);
    }
    else {
      $('.Product').height(heightImage);
    }


    $('.Product__Tabs button').click(function () {
      setTimeout(function () {
        var heightInfo = $('.Product__InfoWrapper').innerHeight();
        var heightImage = $('.Product__Slideshow').innerHeight();

        if (heightInfo > heightImage) {
          $('.Product').height(heightInfo);
        }
        else {
          $('.Product').height(heightImage);
        }
      }, 300);
    });
  }

  if ($(window).width() > 1024) {   
    $(window).on('scroll resize', function () {

      if ($(window).scrollTop() > 100) {
        $('.Slideshow__ImageContainer img').css('display', 'none');
      } else {
        $('.Slideshow__ImageContainer img').css('display', 'block');
      }
    });
  }

  // slick testimanials

  $('.Section-TestimonialList .TestimonialList-slick').slick({
      infinite: true,
      dots: false,
      autoplay: true,
      autoplaySpeed: 4000,
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true,
      prevArrow: "<button type='button' class='slick-prev'></button>",
      nextArrow: "<button type='button' class='slick-next'></button>",
      centerMode: true,
      responsive: [
        {
          breakpoint: 990,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            centerMode: false
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: false
          }
        }
      ]
  });

  // $(".Testimonial.slick-current").next(".Testimonial").addClass("box_shadow");
  sort_by();
  filter_by_tag();
  
  if ($('.template-product').length != 0) {
    customTabs();
    submitCustomizedData();
  }
 });


function sort_by(){
   $("#collection-sort-popover .Popover__Content .Popover__ValueList .Popover__Value").click(function(){
      var option = $(this).text();
      // console.log("option=", option);
      $(".Wp_CollectionToolbar__Item--sort .sort_options_selected").text(option);
   });
   $(".Wp_CollectionToolbar__Item--sort .CollectionToolbar__Item").click(function(){
    $(".PageOverlay").removeClass("is-visible");
    $("html").removeClass('no-scroll');

   });
}

function filter_by_tag(){
   $(".CollectionFilters .wp_filter_by_tag").click(function(){
      $(this).next(".Collapsible__Inner").toggleClass("show");
      $(this).toggleClass('open');

   });

   $(".Linklist .linklist-item .filter-by button").click(function(){
      $(this).parents(".filter-by").next(".list-tag").toggleClass("active");
   });
    $(".list-tag  .Linklist__Item button").click(function(){
      $(".CollectionFilters .Collapsible__Inner").toggleClass("show");
       $(".CollectionFilters .wp_filter_by_tag").toggleClass('open');
   });
}

function customTabs() {
  $('ul.tabs-bar li').click(function(){
		var tab_id = $(this).attr('data-tab');

		$('ul.tabs-bar li').removeClass('current');
		$('.tab-content').removeClass('current');

		$(this).addClass('current');
		$("#"+ tab_id ).addClass('current');
	})
}

function submitCustomizedData() {
  $('.edit-text').click(function() {
    $('.ProductForm__AddEngraving[data-action="open-modal"]').trigger('click');
  })

  $('button[name="submitCustomizedData"]').click(function() {
    const arrResulst = [];
    let line_1 = $('.product-customization-item #line-1').val();
    let line_2 = $('.product-customization-item #line-2').val();
    let line_3 = $('.product-customization-item #line-3').val();
    let line_4 = $('.product-customization-item #line-4').val();
    let line_5 = $('.product-customization-item #line-5').val();
    let line_6 = $('.product-customization-item #line-6').val();
    let line_7 = $('.product-customization-item #line-7').val();
    let line_8 = $('.product-customization-item #line-8').val();
    
    if (line_1 != '') {
      arrResulst.push(line_1);
    }
    if (line_2 != '') {
      arrResulst.push(line_2);
    }
    if (line_3 != '') {
      arrResulst.push(line_3);
    }
    if (line_4 != '') {
      arrResulst.push(line_4);
    }
    if (line_5 != '') {
      arrResulst.push(line_5);
    }
    if (line_6 != '') {
      arrResulst.push(line_6);
    }
    if (line_7 != '') {
      arrResulst.push(line_7);
    }
    if (line_8 != '') {
      arrResulst.push(line_8);
    }

    // localStorage.setItem('results', JSON.stringify(arrResulst));
    // var reSults = localStorage.getItem('results');
    if (arrResulst != null) {
      // reSults = JSON.parse(reSults);
      for (let index = 0; index < arrResulst.length; index++) {
        renderData(arrResulst);
        $('div#results-engraving').show();
      }
    }
   
    $('.Modal__Close').trigger('click');
  }) 
  
}

function renderData(reSults) {
  $('#results-engraving #line1').html(reSults[0]);
  $('#results-engraving #line2').html(reSults[1]);
  $('#results-engraving #line3').html(reSults[2]);
  $('#results-engraving #line4').html(reSults[3]);
  $('#results-engraving #line5').html(reSults[4]);
  $('#results-engraving #line6').html(reSults[5]);
  $('#results-engraving #line7').html(reSults[6]);
  $('#results-engraving #line8').html(reSults[7]);

  $('.engraving-line-1').val(reSults[0]);
  $('.engraving-line-2').val(reSults[1]);
  $('.engraving-line-3').val(reSults[2]);
  $('.engraving-line-4').val(reSults[3]);
  $('.engraving-line-5').val(reSults[4]);
  $('.engraving-line-6').val(reSults[5]);
  $('.engraving-line-7').val(reSults[6]);
  $('.engraving-line-8').val(reSults[7]);
}